import React from 'react';
import logo from '../../assets/logos/Unique_physique-Web2.png';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <img src={logo} alt="Unique Physique" className="loading-logo" />
      <div className="loading-bar">
        <div className="loading-progress"></div>
      </div>
      <p className="loading-tagline">Define Yourself</p>
    </div>
  );
};

export default LoadingScreen;